<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <discount-list
        :discounts="discounts"
        @viewDiscount="selectDiscount"
        @addDiscount="newDiscount"
      ></discount-list>
    </div>
    <div class="md-layout-item md-size-50">
      <discount-tabs :discount="selectedDiscount"></discount-tabs>
    </div>
  </div>
</template>

<script>
import DiscountList from "./DiscountList";
import DiscountTabs from "./DiscountTabs";
import _findIndex from "lodash/findIndex";
import { mapActions, mapGetters } from "vuex";
import { useDiscountStore } from "@/store/modules/discount";

export default {
  components: {
    DiscountList,
    DiscountTabs
  },

  computed: {
    ...mapGetters("discount", ["discounts", "selectedDiscount"])
  },

  methods: {
    ...mapActions("discount", [
      "fetchDiscounts",
      "selectDiscount",
      "newDiscount",
      "clearSelected"
    ])
  },

  mounted() {
    this.clearSelected();
    this.fetchDiscounts();
  }
};
</script>
